// Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer className="footer  py-6">
      <div className="container mx-auto text-center">
        <p>&copy; 2024 EnerByte. Todos los derechos reservados.</p>
       
      </div>
    </footer>
  );
};

export default Footer;